import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import logger from 'ws-scripts/modules/logger';
import { ButtonList } from 'wsm-vehicle-cta-display';
import { ErrorBoundary } from 'wsm-error-boundary';
import { isBrowser } from 'ws-scripts/modules/environment';
import { useRequestData } from 'wsm-common-data';

const Widget = () => {
	const { items } = useSelector(state => state);
	const { windowId } = useRequestData();

	useEffect(() => {
		if (isBrowser && window.DDC && window.DDC.pubsub) {
			setTimeout(
				() =>
					window.DDC.pubsub.publish(
						'ws-vehicle-ctas/render-eprice-portal'
					),
				1000
			);
		}
	}, []);

	const portalMarkup = <div className="eprice-react-portal" />;

	return (
		<ErrorBoundary
			errorHandler={(error, errorInfo) => {
				const newError = new Error(
					`Encountered an error in ws-model-selector.\n${error}`
				);
				newError.originalError = error;
				newError.originalStackTrace = errorInfo.componentStack;
				logger.error(`${newError}\n${newError.originalStackTrace}`);
			}}
		>
			{windowId === 'vehicle-ctas1' && portalMarkup}
			<ButtonList buttons={items} />
		</ErrorBoundary>
	);
};

export default Widget;
